<template>
  <v-layout row wrap v-if="items">
    <template v-for="(item, index) in items">
      <v-flex :xs6="$vuetify.breakpoint.lgOnly || $vuetify.breakpoint.mdOnly  || $vuetify.breakpoint.smOnly"
              :xs4="$vuetify.breakpoint.xlOnly"
              :xs12="$vuetify.breakpoint.xsOnly"
              :px-4="$vuetify.breakpoint.smAndUp"
              :pr-4="$vuetify.breakpoint.xsOnly"
              py-2
              :key="index" v-if="!item.items" class="text-xs-left">
        <v-layout justify-start row wrap class="text-xs-left">
          <v-flex xs11 pr-1 class="text-xs-left">
            <h3>
              <span v-if="item.abbr && item.abbr[$lang.current_lang]" style="color: red">
              {{ item.abbr[$lang.current_lang] }}
              </span>
              {{ item.name[$lang.current_lang] ? item.name[$lang.current_lang] : item.name.en }}
            </h3>
            <p class="text-xs-left" :style="goDark ? 'color: #ffffffb3;margin-bottom: 4px !important;' : 'margin-bottom: 4px !important;'" v-if="item.desc && item.desc[$lang.current_lang]">
              {{ item.desc[$lang.current_lang] ? item.desc[$lang.current_lang] : item.desc.en }}
            </p>
          </v-flex>
          <v-flex xs1 pr-2 class="text-xs-right">
            <span :style="goDark ? 'color: #ffffffb3' : ''" class="price">
                      {{ company && formatPrice(item) ? company.currencySymbol : '' }}{{ formatPrice(item) }}
                    </span>
          </v-flex>

          <v-flex xs12 class="text-xs-left align-center" v-if="item.sizes && item.sizes.length > 1">
            <p style="margin-top: 8px !important; margin-bottom: 4px !important; color: #ffffffb3">Sizes</p>
          </v-flex>
          <template v-for="(size, indexSize) in item.sizes" v-if="item.sizes && item.sizes.length > 1">
            <v-flex xs11 class="text-xs-left align-center">
              <h5 style="line-height: 23px">
                {{ size.name[$lang.current_lang] ? size.name[$lang.current_lang] : size.name.en }}
              </h5>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
            <span :style="goDark ? 'color: #ffffffb3' : ''" class="mr-2 price">
                      {{ company && formatPrice(item, indexSize) ? company.currencySymbol : '' }}{{ formatPrice(item, indexSize) }}
                    </span>
            </v-flex>
          </template>

          <v-flex xs12 class="text-xs-left align-center" v-if="item.styles && item.styles.length > 1">
            <p style="margin-top: 8px !important; margin-bottom: 4px !important; color: #ffffffb3">Styles</p>
          </v-flex>
          <template v-for="(style) in item.styles" v-if="item.styles && item.styles.length > 1">
            <v-flex xs11 class="text-xs-left align-center">
              <h5 style="line-height: 23px">
                {{ style.name[$lang.current_lang] ? style.name[$lang.current_lang] : style.name.en }}
              </h5>
            </v-flex>
          </template>


          <v-flex xs12 class="text-xs-left align-center" v-if="item.variants && item.variants.length > 1">
            <p style="margin-top: 8px !important; margin-bottom: 4px !important; color: #ffffffb3">Variants</p>
          </v-flex>
          <template v-for="(variant) in item.variants" v-if="item.variants && item.variants.length > 1">
            <v-flex xs11 class="text-xs-left align-center">
              <h5 style="line-height: 23px">
                {{ variant.name[$lang.current_lang] ? variant.name[$lang.current_lang] : variant.name.en }}
              </h5>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
            <span :style="goDark ? 'color: #ffffffb3' : ''" class="mr-2 price">
                      {{ company && variant.price ? company.currencySymbol : '' }}{{ variant.price ? variant.price.toFixed(2) : '' }}
                    </span>
            </v-flex>
          </template>

          <v-flex xs12 class="text-xs-left align-center" v-if="item.options && item.options.length > 1">
            <p style="margin-top: 8px !important; margin-bottom: 4px !important; color: #ffffffb3">Options</p>
          </v-flex>
          <template v-for="(option) in item.options" v-if="item.options && item.options.length > 1">
            <v-flex xs11 class="text-xs-left align-center">
              <h5 style="line-height: 23px">
                {{ option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en }}
              </h5>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
            <span :style="goDark ? 'color: #ffffffb3' : ''" class="mr-2 price">
                      {{ company ? company.currencySymbol : '' }}{{ option.price.toFixed(2) }}
                    </span>
            </v-flex>
          </template>

        </v-layout>
      </v-flex>
      <v-layout row wrap px-3 v-if="item.items && item.items.length > 0" style="width: 100%">
        <v-flex xs12>
          <MenuCategories :itemsList="items.filter(x => x.items && x.itemId === item.itemId)" />
        </v-flex>
      </v-layout>
    </template>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  props: ['items', 'env', 'nested'],
  data: () => ({
    companyId: null,
    allergensDialog: false,
    allergens: [],
  }),
  computed: mapGetters({
    company: 'company',
    catalog: 'catalog',
    width: 'width',
    goDark: 'goDark',
  }),
  watch: {
    allergensDialog() {
      setTimeout(() => {
        if (this.allergensDialog) this.allergensDialog = false;
      }, 100);
    },
  },
  created() {
    this.companyId = localStorage.getItem('webShopResourceId');
  },
  methods: {
    findCheapestOptions(list, quantityOfIncludedOptions = 0) {
      if (!list || list.length === 0) {
        return 0;
      }
      let cumulativePrice = 0;
      if (Array.isArray(list) && list.length > 0) {
        const isDeafaultPrice = list.filter(x => x.isDefault === true)
          .sort((a, b) => a.price - b.price);
        if (isDeafaultPrice.length > 0 && quantityOfIncludedOptions > 0) {
          isDeafaultPrice.forEach((option, index) => {
            if (index + 1 > quantityOfIncludedOptions || option.maxIncludedQuantity === 0) {
              cumulativePrice += option.price;
            }
          });
          return cumulativePrice;
        } else if (isDeafaultPrice.length > 0 && quantityOfIncludedOptions === 0) {
          return isDeafaultPrice.reduce((a, b) => a + (b.price || 0), 0);
        }
        return cumulativePrice;
      }
      return cumulativePrice;
    },
    findCheapest(list) {
      if (!list || list.length === 0) {
        return 0;
      }
      let base = 0;
      if (Array.isArray(list) && list.length > 0) {
        base = list[0].price;
        const isDeafaultPrice = list.filter(x => x.isDefault === true);
        if (isDeafaultPrice.length === 1) {
          return isDeafaultPrice[0].price;
        }
        list.forEach((item) => {
          if (item.price < base) {
            base = item.price;
          }
        });
      } else {
        base = list.price;
      }
      return parseFloat(base);
    },
    formatPrice(priceToClacl, k) {
      let price = this.calculatePrice(priceToClacl, k);
      if (price === '') return '';
      if (price === 0) return '';
      price = Number(price).toFixed(2);
      return price;
    },
    calculatePrice(item, k = null) {
      if (k !== null) {
        // eslint-disable-next-line max-len
        return (this.findCheapest(item.variants) + this.findCheapestOptions(item.options, item.quantityOfIncludedOptions) + (item.sizes[k].price || 0));
      }
      if (item.sizes.length > 1 && k !== 0) return '';
      // eslint-disable-next-line max-len
      return (this.findCheapest(item.variants) + this.findCheapestOptions(item.options, item.quantityOfIncludedOptions) + this.findCheapest(item.sizes));
    },
  },
};
</script>
<style lang="scss" scoped>
.price {
  vertical-align: middle;
}

.v-table__overflow {
  height: 102px !important;
}

.desc {
  min-width: 1px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  color: rgba(0, 0, 0, 0.5);
}

@media only screen and (min-width: 600px) {
  .theme--light {
    .table {
      background-color: transparent !important;
    }
  }
}

.cursorHand {
  cursor: pointer;
}

.imageIconClass {
  max-width: 50px;
  max-height: 50px;
  border-radius: 3px;
  padding-top: 8px;
}

.imageIconClassSmall {
  min-width: 25px;
  max-width: 25px;
  max-height: 25px;
  border-radius: 3px;
}

.imageBannerClass {
  border-radius: 3px;
  max-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/MenuItems.vue